module.exports = __webpack_public_path__ + "static/media/nazionale_disabled.cbd178ad.png";